import {
  FETCH_AUDITOR_REPORT_REQUEST,
  FETCH_AUDITOR_REPORT_SUCCESS,
  FETCH_AUDITOR_REPORT_FAILURE,
  FETCH_AUDITOR_REPORT_SUMMARY_REQUEST,
  FETCH_AUDITOR_REPORT_SUMMARY_SUCCESS,
  FETCH_AUDITOR_REPORT_SUMMARY_FAILURE,
  FETCH_PL_REQUEST,
  FETCH_PL_SUCCESS,
  FETCH_PL_FAILURE
} from '../actions/reportActions';

const initialState = {
  auditorReport: {
    reportData: [],
    totals: {
      totalWeight: '0.000',
      totalAmount: '0.00',
      totalTax: '0.00',
      grandTotal: '0.00'
    },
    summary: {
      totalInvoices: 0,
      totalItems: 0,
      dateRange: ''
    }
  },
  auditorReportSummary: {
    summary: {
      totalInvoices: 0,
      totalAmount: '0.00',
      totalTax: '0.00',
      dateRange: 'No data'
    },
    categoryBreakdown: []
  },
  loading: false,
  summaryLoading: false,
  error: null,
  summaryError: null
};

const reportReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_AUDITOR_REPORT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case FETCH_AUDITOR_REPORT_SUCCESS:
      return {
        ...state,
        loading: false,
        auditorReport: action.payload,
        error: null
      };

    case FETCH_AUDITOR_REPORT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_AUDITOR_REPORT_SUMMARY_REQUEST:
      return {
        ...state,
        summaryLoading: true,
        summaryError: null
      };

    case FETCH_AUDITOR_REPORT_SUMMARY_SUCCESS:
      return {
        ...state,
        summaryLoading: false,
        auditorReportSummary: action.payload,
        summaryError: null
      };

    case FETCH_AUDITOR_REPORT_SUMMARY_FAILURE:
      return {
        ...state,
        summaryLoading: false,
        summaryError: action.payload
      };

    // Profit & Loss
    case FETCH_PL_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_PL_SUCCESS:
      return {
        ...state,
        loading: false,
        pl: action.payload,
        error: null
      };
    case FETCH_PL_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};

export default reportReducer;
